const KEY = 'quizGardenHighScores';
const LEGACY_KEY = 'highScores';
const MAX_SCORES = 5;

const safeParse = (value) => {
  try {
    return JSON.parse(value) || [];
  } catch {
    return [];
  }
};

const normalizeScore = (entry) => ({
  name: entry.name || 'Player',
  score: Number(entry.score) || 0,
  total: Number(entry.total) || Number(entry.questions) || 0,
  correct: Number(entry.correct) || 0,
  questions: Number(entry.questions) || 0,
  category: entry.category || 'All',
  difficulty: entry.difficulty || 'Any',
  type: entry.type || 'Any',
  at: Number(entry.at) || Date.now(),
});

export function saveHighScore(entry) {
  const scores = getHighScores();
  const nextScores = [
    ...scores,
    normalizeScore({
      ...entry,
      at: Date.now(),
    }),
  ]
    .sort((a, b) => b.score - a.score || a.at - b.at)
    .slice(0, MAX_SCORES);

  localStorage.setItem(KEY, JSON.stringify(nextScores));
}

export function getHighScores(limit = MAX_SCORES) {
  const current = safeParse(localStorage.getItem(KEY));
  const legacy = safeParse(localStorage.getItem(LEGACY_KEY));
  const scores = (current.length ? current : legacy)
    .map(normalizeScore)
    .sort((a, b) => b.score - a.score || a.at - b.at)
    .slice(0, MAX_SCORES);

  if (typeof limit === 'number') return scores.slice(0, limit);
  return scores;
}

export function clearHighScores() {
  localStorage.removeItem(KEY);
  localStorage.removeItem(LEGACY_KEY);
}
